const businessCategoryRoutes = [

    {
        path: 'business-categories',
        name: 'businesscategory',
        component: () => import('./ListBusinessCategory.vue'),
        meta: {
            auth: true,
            title: 'Business Categories',
            breadcrumb: 'Business Categories',
            permission: ['view business-category']
        }
    },


    {
        path: 'create-businesscategory',
        name: 'createbusinesscategory',
        component: () => import('./CreateEditBusinessCategory.vue'),
        meta: {
            auth: true,
            title: 'Create Business Category',
            breadcrumb: 'Create Business Category',
            permission: ['create business-category']
        }
    },


    {
        path: ':id/edit',
        name: 'editbusinesscategory',
        component: () => import('./CreateEditBusinessCategory.vue'),
        meta: {
            auth: true,
            title: 'Edit Business Category',
            breadcrumb: 'Edit Business Category',
            permission: ['update business-category']
        }

    },

];


export default businessCategoryRoutes;
